import jump from 'jump.js'
const load = () => {

  document.querySelectorAll('.js-link-button').forEach(elm => {
    // eslint-disable-next-line no-useless-escape
    try {
      const id = '#' + elm.dataset.idLink.replace(/^#/g, '').replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, '\\$&')
      elm.addEventListener('click', () => {
        let t = document.querySelector(id)
        if (t) {
          jump(t, {})
        }
      })
    } catch {

    }

  })
}
export default load